module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraBold.138f421.woff2";